import sprintf from "sprintf-js";
import React, {useEffect, useState} from 'react';
import {useZooPassAppContext} from "../../Context/ZooPassAppContext";
import {IZooPassAnswersContext, useZooPassAppAnswersContext, ZooPassAppAnswersContext} from "../../Context/ZooPassAnswersContext";

export const Step8SidebarValue: React.FC = () => {

    let {
        zooPassMembership,
        numericValues,
        loading
    } = useZooPassAppContext();

    let {
        answersData,
        answersLoading
    } = useZooPassAppAnswersContext();

    const [text, setText] = useState<string>();

    useEffect(() => {
        if (loading || answersLoading || answersData == null) {
            setText("");
            return;
        }
        if (answersData.step8Value == null || answersData.step8IdValue == null || answersData.step7Value == null) {
            setText("");
            return;
        }
        const membership = zooPassMembership.get(answersData.step7Value);
        if (membership == null) {
            setText("");
            return;
        }

        const valueFormat = numericValues.get("ZooPass:ProgressValue:08:Timeframe");
        if (valueFormat != null) {
            if (answersData.step8Value === 1) {
                setText(valueFormat.format1 ?? "");
            }
            if (answersData.step8Value > 1) {
                setText(sprintf.sprintf(valueFormat.formatN ?? "%s", answersData.step8Value));
            }
        }
    }, [answersData?.step7Value, answersData?.step8Value, loading, answersLoading]);

    return (<><span>{text}</span></>);
};

